module.exports = __webpack_public_path__ + "img/maatcomputers.42e259b8.jpg";